module.exports = __webpack_public_path__ + "static/media/client-trust.de56d9a4.jpeg";